import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import {getArticlesHowToEarn} from '../../actions/how-to-earn';
import {loadPageContent} from '../../actions/content';
import NewsList from '../common/article/news-list';
import ArticleList from '../common/article/article-list';

class HowToEarn extends Component {
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'how-to-earn';
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getArticlesHowToEarn());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const { contents, articlesList, area } = this.props;
    return (
      <Container fluid className="how-to-earn newslist user-inner-container">
        <Row>
          <Col className="newslist-title" lg={12}>
            <PageTitle>
              How to earn
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              contents={contents[`${this.pageSlug}_how_to_earn_header`]}
              identifier={`${this.pageSlug}_how_to_earn_header`}
              onContentSaved={this.handleContentSaved}
            />
          </Col>
        </Row>
        {(area !== 'retailer' && area !== 'pre_login') && (
          <Row>
            <Col lg={12}>
              <ArticleList articles={this.props.articlesList}/>
            </Col>
          </Row>
        )}
        {(area === 'retailer' || area === 'pre_login') && (
          <Row className="newslist-news">
            <Col lg={12}>
              <NewsList articles={articlesList}/>
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  articlesList: state.howToEarn.howToEarnArticles,
  fetching: state.howToEarn.fetching,
  fetched: state.howToEarn.fetched,
  contents: state.content.list
});

export default connect(mapStateToProps)(HowToEarn);
